import { intl } from './intl';

export const { t: pageT, Message: PageMessage } = intl.createMessages({
    videoUploadFull: {
        ru: 'Загрузить новое видео',
        en: 'Upload new video',
    },
    videoUploadShort: {
        ru: 'Загрузить',
        en: 'Upload',
    },
    videoListFull: {
        ru: 'Мои видео',
        en: 'My videos',
    },
    videoListShort: {
        ru: 'Мои видео',
        en: 'My videos',
    },
    orderAccess: {
        ru: 'Заказать доступ',
        en: 'Request access',
    },
    searchByTitle: {
        ru: 'Поиск по названию',
        en: 'Search by title',
    },
    dateFrom: {
        ru: 'От',
        en: 'From',
    },
    dateTo: {
        ru: 'До',
        en: 'To',
    },
    datePlaceholder: {
        ru: 'ДД/ММ/ГГГГ ЧЧ:ММ:СС',
        en: 'DD/MM/YYYY HH:MM:SS',
    },
    invalidDate: {
        ru: 'Некорректная дата',
        en: 'Invalid date',
    },
    dateFromAfterDateTo: {
        ru: 'Дата "от" не может быть позже даты "до"',
        en: '"From" date cannot be later than "to" date',
    },
    profileYandexNDA: {
        ru: 'Яндекс NDA',
        en: 'Yandex NDA',
    },
    profileYandexBSTNDA: {
        ru: 'Яндекс + КПБ NDA',
        en: 'Yandex + Business Support Team NDA',
    },
    profileYandexBSTConsultantsNDA: {
        ru: 'Яндекс + КПБ + Консультанты NDA',
        en: 'Yandex + Business Support Team + Consultants NDA',
    },
    promoAlertTitle: {
        ru: 'Для серьёзных вещей используйте Internal Video',
        en: 'For serious matters use Internal Video',
    },
    promoAlertIntro: {
        ru: 'Если хотите загрузить:',
        en: 'If you want to upload:',
    },
    promoAlertTeamVideos: {
        ru: 'обучающие видео команды (КМБ)',
        en: 'team training videos (KMB)',
    },
    promoAlertImportantMeetings: {
        ru: 'записи важных встреч',
        en: 'recordings of important meetings',
    },
    promoAlertAction: {
        ru: 'Попробуйте Internal Video',
        en: 'Try Internal Video',
    },
});
